export const SPORTSNEW_MEMBERSHIP_INVALIDATE_EVENT = 'sportsnew:membership:invalidate';

const VALID_MODES = new Set(['prematch', 'live', 'all']);

const normalizedMode = value => String(value ?? '').trim().toLowerCase();
const normalizedSport = value => {
  const sport = String(value ?? '').trim().toLowerCase();
  return sport || null;
};

export function normalizeSportsnewMembershipInvalidation(raw) {
  const payload = raw?.patch && typeof raw.patch === 'object'
    ? { ...raw, ...raw.patch }
    : raw;
  if (!payload || typeof payload !== 'object') return null;

  const mode = normalizedMode(payload.mode);
  if (!VALID_MODES.has(mode)) return null;

  const fixtureId = Number(payload.fixtureId ?? payload.fixture_id);
  const sports = [...new Set((Array.isArray(payload.sports) ? payload.sports : [])
    .map(normalizedSport)
    .filter(Boolean))];
  const sport = normalizedSport(payload.sport) ?? sports[0] ?? null;

  return Object.freeze({
    fixtureId: Number.isSafeInteger(fixtureId) && fixtureId > 0 ? fixtureId : null,
    mode,
    sport,
    sports,
    reason: String(payload.reason ?? '').trim() || null,
    emittedAt: payload.emittedAt ?? payload.emitted_at ?? null,
  });
}

export function sportsnewMembershipInvalidationAffectsMode(invalidation, currentMode) {
  if (!invalidation) return false;
  const activeMode = normalizedMode(currentMode);
  if (!VALID_MODES.has(activeMode)) return false;
  return invalidation.mode === 'all'
    || activeMode === 'all'
    || invalidation.mode === activeMode;
}
